// src/components/register/QualificationsDropdown.tsx

import React, { useState } from 'react';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuGroup,
} from '@radix-ui/react-dropdown-menu';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { Button } from '../../styles/_app.style'; 
import { Item } from '../../styles/navigation.style'; 
import { Content } from '../navigation/navDropdowns/navDropdown.style'; 

type Option = { value: string; label: string };
type OptionGroup = { label:string; options: Option[] };

interface QualificationsDropdownProps {
  value: string;
  onChange: (val: string) => void;
  options: OptionGroup[];
}

const QualificationsDropdown: React.FC<QualificationsDropdownProps> = ({
  value,
  onChange,
  options,
}) => {
  const [open, setOpen] = useState(false);

  const displayLabel = 
    options.flatMap(group => group.options).find(opt => opt.value === value)?.label || value;

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild data-dropdown="qualification">
        <Button
          icon
          css={{
            // 1. Force Full Width
            width: '100%',
            
            // 2. Flex Layout
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between', // Pushes icon to right
            textAlign: 'left',
            
            // 3. Sizing & Spacing
            minWidth: '9rem',
            padding: '0 1rem', // Match your standard input padding
            gap: '0.5rem',
            fontSize: '$sm',
            
            // 4. Handle text wrapping if qualification names are long
            height: 'auto',
            minHeight: '2.75rem',
            whiteSpace: 'normal',
          }}
          aria-label="Select qualification"
          title="Select qualification"
        >
          <span>{displayLabel}</span>
          
          {/* 👇 THE FIX: flexShrink: 0 prevents the icon from squishing */}
          <span style={{ display: 'flex', flexShrink: 0 }}>
             {open ? <FiChevronUp /> : <FiChevronDown />}
          </span>
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        align="start"
        sideOffset={4}
        style={{
            maxHeight: '15rem',
            overflowY: 'auto',
            zIndex: 999,
            fontSize: 'var(--fontSizes-sm)', 
        }}
        asChild
      >
        <Content style={{ minWidth: 'var(--radix-dropdown-menu-trigger-width)' }}>
          {options.map(group => (
            <DropdownMenuGroup key={group.label}>
              <DropdownMenuLabel style={{ 
                padding: '0.5rem 0.75rem', 
                fontWeight: 'bold', 
                color: '#4b5563',
                fontSize: '0.85em'
             }}>
                {group.label}
              </DropdownMenuLabel>
              {group.options.map(opt => (
                <Item
                  key={opt.value}
                  onSelect={() => onChange(opt.value)}
                  style={{ width: '100%' }}
                  title={opt.label}
                >
                  {opt.label}
                </Item>
              ))}
            </DropdownMenuGroup>
          ))}
        </Content>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default QualificationsDropdown;